import React, { useState } from "react";
import { useFeatures } from "flagged";
import { Route, Routes } from "react-router";
import { v4 as uuid } from "uuid";
import { ROUTES } from "../constants";
import { AmplifyAuth, Restrict } from "./Authentication";
import { getRoute } from "../helpers";
import NotFound from "./NotFound";
import {
  AuthConfirmation,
  ForgotPassword,
  LogIn,
  SelectWorkspace,
  SetPassword,
  SignUp,
  GithubRedirect,
} from "../pages/AuthScreens";
import Home from "./Home";

const {
  AUTH_CONFIRMATION,
  FORGOT_PASSWORD,
  HOME,
  LOGIN,
  SET_PASSWORD,
  SELECT_WORKSPACE,
  SIGNUP,
  GITHUB_CALLBACK,
} = ROUTES;

const unSecuredRoutes = [
  AUTH_CONFIRMATION,
  FORGOT_PASSWORD,
  LOGIN,
  SET_PASSWORD,
  SIGNUP,
];

const RoutesLayout = ({ shouldShowNavAndSidePanel }) => {
  const features = useFeatures();
  const isUnsecuredRoute = unSecuredRoutes.includes(window.location.pathname);

  const [isSigningUp, setIsSigningUp] = useState(false);

  return (
    <>
      <Routes>
        {Object.entries(features).map(([feature, featureValue]) => {
          if (featureValue)
            return (
              <React.Fragment key={uuid()}>
                {getRoute(feature, shouldShowNavAndSidePanel)}
              </React.Fragment>
            );
          else return null;
        })}
        <Route
          exact
          path={SELECT_WORKSPACE}
          element={
            <AmplifyAuth>
              <SelectWorkspace />
            </AmplifyAuth>
          }
        />
        <Route
          exact
          path={HOME}
          element={
            <AmplifyAuth>
              <Home />
            </AmplifyAuth>
          }
        />
        <Route
          exact
          path={LOGIN}
          element={
            <Restrict
              shouldShowNav={shouldShowNavAndSidePanel}
              isUnsecuredRoute={isUnsecuredRoute}
            >
              <LogIn />
            </Restrict>
          }
        />
        <Route exact path={GITHUB_CALLBACK} element={<GithubRedirect />} />
        <Route
          exact
          path={SIGNUP}
          element={
            <Restrict
              shouldShowNav={shouldShowNavAndSidePanel}
              isUnsecuredRoute={isUnsecuredRoute}
            >
              <SignUp setIsSigningUp={setIsSigningUp} />
            </Restrict>
          }
        />
        <Route
          exact
          path={FORGOT_PASSWORD}
          element={
            <Restrict
              shouldShowNav={shouldShowNavAndSidePanel}
              isUnsecuredRoute={isUnsecuredRoute}
            >
              <ForgotPassword />
            </Restrict>
          }
        />
        <Route
          exact
          path={SET_PASSWORD}
          element={
            <Restrict
              shouldShowNav={shouldShowNavAndSidePanel}
              isUnsecuredRoute={isUnsecuredRoute}
            >
              <SetPassword setIsSigningUp={setIsSigningUp} />
            </Restrict>
          }
        />
        {isSigningUp && <Route
          exact
          path={AUTH_CONFIRMATION}
          element={
            <Restrict
              shouldShowNav={shouldShowNavAndSidePanel}
              isUnsecuredRoute={isUnsecuredRoute}
            >
              <AuthConfirmation />
            </Restrict>
          }
        />}
        <Route
          path="*"
          element={
            <AmplifyAuth>
              <NotFound />
            </AmplifyAuth>
          }
        />
      </Routes>
    </>
  );
};

export default RoutesLayout;
